/**
 * Shipper HQ
 *
 * @copyright Copyright (c) 2026 Zowta Ltd (http://www.shipperhq.com)
 * Copyright, 2026, Zowta, LLC - US license
 */

import React from 'react'
import PlatformIcon from 'components/frontend/signup/PlatformIcon'
import CsrfField from './CsrfField'
import * as Constants from './constants'
import LoginHeader from './LoginHeader'

export default function BCForm() {
    return (
        <>
            <LoginHeader title="Welcome" />
            <form
                rel="noreferrer"
                className="button_to"
                method="post"
                action="https://login.bigcommerce.com/login"
            >
                <CsrfField />
                <PlatformIcon platform={Constants.BIGCOMMERCE} />
                <p className="mb20">To login...</p>
                <button type="submit" className="btn btn-lg btn-orange sign_in_button mb30">
                    Sign in to BigCommerce
                </button>
            </form>
        </>
    )
}
